import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router';

import ConfirmUpgrade from './pages/ConfirmUpgrade';
import FeaturePreview from './pages/FeaturePreview';
import * as routes from './routes';

const Upgrade: FC = () => (
  <Switch>
    {/*
     *  On accessing /upgrade, redirect to /upgrade/choice
     *
     *  The router defined in src/Main/SecuredRoutes/index takes precedence
     *  as /upgrade/choice is a full-page and thus can't be rendered as a child of the regular app layout
     */}
    <Route
      exact
      path={routes.root}
      render={() => <Redirect to={routes.choice} />}
    />
    <Route component={ConfirmUpgrade} path={routes.confirm} />
    <Route component={FeaturePreview} path={routes.featurePreview} />
  </Switch>
);

export default Upgrade;
